module.exports = __webpack_public_path__ + "images/826901d7a6616396d04cfec6da82b85b.png";